module.exports = __webpack_public_path__ + "img/ELABORACION-PALABRA.c72453bb.png";